import ImageSlider from "../blocks/image-slider";
import GallerySlider from "../blocks/gallery-slider";

const CaseStudies = {
  init() {
    new ImageSlider(".case-study .image-slider");
    new GallerySlider(".case-study .gallery");
  },
};

export default CaseStudies;
